import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'moment',
  pure: true,
})
export class MomentPipe implements PipeTransform {

  transform(item: moment.Moment | null | undefined, format: string): any {
    return item ? item.format(format) : null;
  }

}
